<template>
  <div style="display: inline-block">
    <slot>
      <v-tooltip
        bottom
        v-if="
          hasCancellableItems() &&
            ($store.state.Auth.userProperties.user_id === this.travel_service.created_by_id || $store.getters.hasPermission('travelOrder'))
        "
      >
        <template #activator="{on}">
          <v-btn @click="dialog = true" icon v-on="on">
            <v-icon>fa-ban</v-icon>
          </v-btn>
        </template>
        {{ $t("travelService.cancelBooking") }}
      </v-tooltip>
    </slot>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-col cols="12" class="px-0">
            <h2>{{ $t("travelService.cancellationDialogTitle") }}</h2>
          </v-col>
          <v-col cols="12" style="text-align: center" v-if="loading">
            <v-progress-circular indeterminate color="primary" size="105" />
            <h3 class="mt-4">{{ $t("global.loading") }}</h3>
          </v-col>
          <v-row v-for="cancelableTravelService of cancelableTravelServices" :key="cancelableTravelService.id" class="my-3">
            <div style="max-width: 50px;"><v-checkbox class="mx-2 mt-0" :value="cancelableTravelService.id" v-model="idServicesToCancel" hide-details /></div>
            <travel-service-order-item-chip :travel-service-order-item="cancelableTravelService" class="my-0 py-0" />
          </v-row>
          <v-alert outlined type="info">
            {{ $t("travelService.cancellationAlert") }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click.native="dialog = false" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="idServicesToCancel.length === 0 || $store.getters['Ajax/loading']" @click.native="save()" color="blue darken-1" text>
            {{ $t("global.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { itemsStatus } from "../../staticData/ServiceOrder";
import TravelServiceOrderItemChip from "./Chips/TravelServiceOrderItemChip";

export default {
  name: "CancellationComponent",
  components: { TravelServiceOrderItemChip },
  data: () => ({
    dialog: false,
    idServicesToCancel: [],
    cancelableTravelServices: [],
    loading: false
  }),
  props: {
    travel_service: {
      required: true
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.downloadAssignedTravelServiceItems();
      }
    }
  },
  methods: {
    downloadAssignedTravelServiceItems() {
      this.loading = true;
      this.axios.get("travel-service/get-assigned?id=" + this.travel_service.id).then(resp => {
        this.cancelableTravelServices = resp.data;
        this.loading = false;
      });
    },
    hasCancellableItems() {
      for (let travelServiceItem of this.travel_service.travel_service_items) {
        if (
          [itemsStatus.STATUS_BOOKED, itemsStatus.STATUS_OFFER_ACCEPTED_BY_CLIENT, itemsStatus.STATUS_REQUEST_CLIENT_ANSWER_FOR_BOOK].includes(
            travelServiceItem.status
          )
        ) {
          return true;
        }
      }
      return false;
    },
    save() {
      this.axios.post("travel-service/cancel-order-items", { travelServiceOrderItemsIds: this.idServicesToCancel }).then(() => {
        this.dialog = false;
        this.$store.dispatch("snackbarPush", {
          text: this.$t("global.saved"),
          position: "down"
        });
        this.$emit("changed");
      });
    }
  }
};
</script>

<style scoped></style>
